import ShortMonthHandlingType from "@/models/Shared/ShortMonthHandlingType";

export default (shortMonthHandlingType: ShortMonthHandlingType) => {
    let returnVal = "Undefined";
    switch (shortMonthHandlingType) {
        case ShortMonthHandlingType.LastDayOfMonth:
            returnVal = "Last Day Of Month";
            break;
        case ShortMonthHandlingType.FirstDayOfMonth:
            returnVal = "First Day Of Month";
            break;
    }
    return returnVal;
}